module.exports = __webpack_public_path__ + "img/Componente 30 – 1.dc464e33.svg";